const initialState = {
  open: true
};

function SideBarReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_CURRENT_SIDE_BAR':
      return {
        ...state,
        open: action.value.open
      };
    default:
      return state;
  }
}

export default SideBarReducer;
